import {AbstractList} from "./abstract-list";

export class FavoriteTaskList extends AbstractList {
  constructor(item: HTMLElement) {
    super(item);
  }
}
